<template>
    <div class="freeVipInfo" v-if="showFreeVipInfo">
			<div class="freeVipInfoBox">
                <img src="@/assets/images/vip/meBg.png" alt="">
				<i class="el-icon-close" @click="closeFreeVipInfo"></i>
				<div class="mainTitle">免费赠送您3天每日会员！</div>
				<div class="vipTypeList">
					<div class="title">开通会员免费使用</div>
					<div class="introduce">畅享模版、无限浏览次数等更多会员功能</div>
					<div class="vipTypeBox">
						<template v-for="(item) in vipTypeList">
							<div class="vipTypeItem"
								:key="item.title+'dsf'"
								v-if="item.vippaytype != 'free_pay'"
								@click="jumpToVip(item)"
								>
								<div class="itemTitle">{{ item.title }}</div>
								<div class="price">
									<span>{{ item.payamount }}</span>{{ item.unit }}
								</div>
								<div class="vipTypeDesc" :style="getVipTypeDesc(item).style" v-if="getVipTypeDesc(item).text && item.payamount > 0">{{ getVipTypeDesc(item).text }}</div>
							</div>
						</template>
					</div>
				</div>
				<div class="vipIntroduce">
					<span>邀请您花更少的钱，获取更多的资源</span>
                    <p>为了给您提供更好的服务，我们上线了会员体系，针对新用户我们免费赠送给您3天每日会员，您可直接进行体验，享受会员带来的优势。也可以直接选择更加具有优势的年费会员。感谢您长期以来的支持！</p>
				</div>
				<div class="buttonBox">
					<el-button class="button" @click="reciveVip">{{ sureBtnText }}</el-button>
				</div>
			</div>
		</div>
</template>

<script>
import { getDict,matchDict } from '@/assets/js/dict'
import { mapGetters,mapActions, mapMutations } from 'vuex';
    export default {
        data(){
            return{
                showFreeVipInfo: false,
                vipTypeList:[],
                vipTypeDictList:[],
                vipPayTypeList:[],
                sureBtnText:''
            }
        },
        computed: {
        ...mapGetters({
            userinfo: 'userinfo/getData',
        }),
    },
    watch:{
        userinfo:{
            handler(e){
                if(e){
                this.checkShowVipDialog()
                this.getDictFn()
                }
            },deep:true
        }
    },
        methods:{
            getDictFn(){
                Promise.all([
                    getDict('vip_pay_type'),	
                    getDict('vip_type'),	
                ]).then(res=>{
                    this.vipPayTypeList= res[0]
                    this.vipTypeDictList = res[1]
                })
            },
            // vip价格列表
            getVipTypeList() {
                this.$get(`${this.$store.state.api.webUrl}/vipintroduce/list.json`,{},data=>{
                    this.vipTypeList = data.map((item, index) => {
                        item.title = matchDict(this.vipTypeDictList, item.viptype)
                        switch (item.viptype) {
                            case 'day_vip' : 
                            item.unit = '元/日'
                            break
                            case 'year_vip' : 
                            item.unit ='元/月'
                            break
                            case 'super_vip':
                            item.unit='元/年'
                            break
                            default :
                            item.unit = '元'
                        }
                        return item
                    })
                    this.showFreeVipInfo = true
                })
            },
            getVipTypeDesc(item) {
                  switch(item.viptype){
                      case 'day_vip':
                            return {
                            text: '每日',
                            style: {
                                background: '#F59A23',
                                color: 'white'
                            }
                        }
                    case 'year_vip':
                         return {
                            text: '全年',
                            style: {
                                background: 'lightgreen',
                                color: 'black'
                            }
                        }
                    case 'super_vip':
                         return {
                            text: '全年',
                            style: {
                                background: 'lightgreen',
                                color: 'black'
                            }
                        }
                    default: 
                        return {
                            text: '',
                            style: {
                                background: 'lightgreen',
                                color: 'black'
                            }
                        }
                }

                return
                // switch(item.vippayway){
                //     case 1 :
                //         return {
                //             text: '每日',
                //             style: {
                //                 background: '#F59A23',
                //                 color: 'white'
                //             }
                //         }
                //     case 12 :
                //         return {
                //             text: '全年',
                //             style: {
                //                 background: 'lightgreen',
                //                 color: 'black'
                //             }
                //         }
                //     default: 
                //         return {
                //             text: '',
                //             style: {
                //                 background: 'lightgreen',
                //                 color: 'black'
                //             }
                //         }
                // }
            },
            // 关闭弹窗
            closeFreeVipInfo() {
                setSession('isFirstLogin', 0);
                setSession('showReceiveVip', 0);
                this.showFreeVipInfo = false
            },
            // 领取会员
            reciveVip() {
                if(getSession('showReceiveVip') == 1){ //没有购买过 领取会员
                    this.$get(`${this.$store.state.api.webUrl}/uservip/receiveFree.json`,{},data=>{
                        if(data.result){
                            this.$notify.info('领取成功')
                            this.queryUserInfo({ requery: true });
                            setTimeout(()=>{
                                window.location.reload()
                            },200)
                        }
                    })
                }
                this.closeFreeVipInfo()
            },
            // 跳转到会员页面
            jumpToVip(item) {
                // setSession('isFirstLogin', 0);
                // setSession('showReceiveVip', 0);
                // this.$router.push({
                //     path: '/user/assets/vip?vipType=' + item.viptype
                // })
                window.location.href='/user/assets/vip?vipType=' + item.viptype
                this.closeFreeVipInfo()
            },
            // 验证是否需要弹窗
            checkShowVipDialog() {
                if(getSession('isFirstLogin') == 1 || getSession('showReceiveVip') == 1){
                    this.getVipTypeList()
                }
                if(getSession('isFirstLogin') == 1){
                    this.sureBtnText = '我知道了'
                }
                if(getSession('showReceiveVip') == 1){
                    this.sureBtnText = '领取'
                }
            },

            ...mapMutations({
                updateData: 'userinfo/updateData',
            }),

            ...mapActions({
                queryUserInfo: 'userinfo/queryUserInfo',
            }),
        },
        mounted(){
            if(this.userinfo){
                this.checkShowVipDialog()
                this.getDictFn()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .freeVipInfo {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 12012512121;
        .freeVipInfoBox {
            position: relative;
            width: 611px;
            height: 591px;
            border-radius: 10px;
            background: #fff;
            i {
                position: absolute;
                font-size: 40px;
                right: -40px;
                top: -20px;
                color: white;
                cursor: pointer;
            }
            img{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 258px;
                z-index: 1;
            }
            .mainTitle {
                color: #fff;
                font-size: 30px;
                margin-top: 44px;
                margin-left: 39px;
                font-weight: 700;
                z-index: 5;
            }
            .vipTypeList {
                width: 553px;
                height: 258px;
                margin: 0 auto;
                margin-top: 40px;
                border-radius: 8px;
                background: white;
                padding-top: 17px;
                border: 1px solid #EBE6E6;
                z-index: 15;
                .title {
                    text-align: center;
                    font-size: 18px;
                    color: #1d1d1d;
                    font-weight: bold;
                }
                .introduce {
                    text-align: center;
                    font-size: 18px;
                    color: #676767;
                    margin-top: 10px;
                }
                .vipTypeBox {
                    display: flex;
                    justify-content: space-around;
                    padding: 20px ;
                    .vipTypeItem {
                        width: 148px;
                        height: 125px;
                        border-radius: 8px;
                        cursor: pointer;
                        overflow: hidden;
                        background-color: #F4F9FC;
                        position: relative;
                        text-align: center;
                        border: 4px solid #f4f9fc;
                        .itemTitle {
                            font-size: 19px;
                            font-weight: bold;
                            padding: 20px 0 20px;
                        }
                        .price {
                            font-size: 16px;
                            color: #FF4D30;
                            span {
                                font-weight: 700;
                                font-size: 30px;
                                color: #FF4D30;
                            }
                        }
                        .vipTypeDesc {
                            width: 85px;
                            height: 20px;
                            line-height: 20px;
                            text-align: center;
                            position: absolute;
                            top: 3px;
                            right: -30px;
                            transform: rotate(45deg);
                            transform-origin: center;
                            font-size: 12px;
                            background: #F59A23;
                        }
                    }
                    .vipTypeItem:first-child{
                        background-color: #F7F2E7;
                        border: 4px solid #FFC96F;
                    }
                    
                }
            }
            .vipIntroduce {
                padding: 15px 30px;
                line-height: 22px;
                color: #252525;
                font-size: 13px;
                span {
                    font-weight: bold;
                    color: #252525;
                    font-size: 18px;
                }
                p{
                    margin-top: 10px;
                }
            }
            .buttonBox {
                text-align: center;
                .button {
                    width: 210px;
                    height: 56px;
                    color: white;
                    background: #3D7EFF;
                    border-radius: 28px;
                }
            }
        }
    }
</style>